import { Box } from '@mui/material';
import unauthorized from 'assets/403.png';
import { useTitle } from 'shared/hooks';

export function UnauthorizedPage() {
  useTitle('Unauthorized');
  return (
    <Box
      sx={{
        background: `url(${unauthorized}) no-repeat center center fixed`,
        backgroundSize: 'cover',
        height: `calc(100vh - 70px)`,
        mx: -3,
        mt: -3.5,
      }}
    ></Box>
  );
}
